import * as React from "react"
import { DragDropContext, Droppable } from "react-beautiful-dnd"
import type { DragDropContextProps } from "react-beautiful-dnd"

import DelayedScroller from "shared/components/DelayedScroller"
import useAutoscroll from "shared/hooks/useAutoscroll"

import DefaultStyle from "./DefaultStyle"
import Item from "./Item"
import type { Navigator } from "./types"

export function createNavigator<ItemType extends { id: number }>(): Navigator<ItemType> {
  const Navigator: Navigator<ItemType> = ({
    items,
    selectItem,
    selectedId,
    moveItem,
    renderItem,
    className,
  }): JSX.Element => {
    const $scrollerInsideRef = React.useRef<HTMLDivElement>(null)
    useAutoscroll($scrollerInsideRef, selectedId !== undefined ? String(selectedId) : undefined)

    const onDragEnd: DragDropContextProps["onDragEnd"] = ({ source, destination }) => {
      const item = items[source.index]
      if (destination) moveItem(item, destination.index)
    }

    return (
      <DelayedScroller ref={$scrollerInsideRef}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="navigator">
            {(provided, { isDraggingOver }) => (
              <DefaultStyle.List
                {...provided.droppableProps}
                ref={provided.innerRef}
                data-testid="catalog-navigator"
                className={className}
              >
                {items.map((item, index) => {
                  const isSelected = item.id === selectedId
                  return <Item key={item.id} {...{ item, index, selectItem, isDraggingOver, isSelected, renderItem }} />
                })}
                {provided.placeholder}
              </DefaultStyle.List>
            )}
          </Droppable>
        </DragDropContext>
      </DelayedScroller>
    )
  }
  return Navigator
}

export { default as DefaultStyle } from "./DefaultStyle"

export { default as MoveHandle } from "./MoveHandle"
